module.exports = __webpack_public_path__ + "Flag-414.745fe788c8461a2ab5de22bcb243466c.svg";